module.exports = __webpack_public_path__ + "Ubuntu-Bold.e00e2a77dd88a8fe7557.ttf";


//////////////////
// WEBPACK FOOTER
// D:/F210-INGRESO/cambio_enlace_ayuda/rec_ng_ingresorenta210/src/assets/fonts_v2/Ubuntu/Ubuntu-Bold.ttf
// module id = ../../../../../src/assets/fonts_v2/Ubuntu/Ubuntu-Bold.ttf
// module chunks = styles